export default "__VITE_PUBLIC_ASSET__5ae6e704__"